import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './services/snackbarUtils';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <SnackbarProvider maxSnack={3} autoHideDuration={3000} preventDuplicate>
        <SnackbarUtilsConfigurator />
        <App/>
    </SnackbarProvider>
);